import { Store } from "pullstate";

export const ProductStore = new Store({
    
    products: [],
    hasLoaded: false,
    fullyLoaded: false,
    suggestProducts: [],
    totalProducts: 0,
    currentPage: 1,
    pagination: {
        to: 0,
        total: 0,
        current_page: 1,
        per_page: 0,
        last_page: 0
    } 
});